/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum GlobalSearchKinds {
    Customer = 10,
    Project = 20,
    ProjectLineItem = 30,
    Product = 40,
}
